import React, { Component } from 'react';
import companyService from '../../services/company';
import './index.css';

export default class CompaniesContact extends Component {
  state = {
    companies: null
  };

  componentDidMount() {
    return companyService.data()
    .then(this.updateFieldInState.bind(this, 'companies'));
  }

  updateFieldInState(field, value) {
    if (value) {
      value = value.map(article => Object.assign({}, article, {expanded: false}));
    }

    this.setState({
      [field]: value
    });
  }

  renderContent() {
    let rendered = null;

    if (this.state.companies) {
      //<h6>Email: <b>{company.email}</b></h6>
      rendered = this.state.companies.map(company => (
        <div className="comp-companiescontact__company col-md-6 u-m-t-small">
          <a href={company.url} target="_blank">
            <div className="comp-companiescontact__company__banner" style={{backgroundImage: `url(${company.banner})`}}>
              <img className="comp-companiescontact__company__banner__logo" src={company.logo} />
            </div>
          </a>

          <div className="comp-companiescontact__company__details">
            <h6>Telefon: <a href={`tel:${company.phone}`}>{company.phone}</a></h6>
          </div>
        </div>
      ));
    }

    return (
      <div className="comp-companiescontact row">
        {rendered}
      </div>
    );
  }

  render() {
    let rendered = null;

    if (this.state.companies) {
      rendered = this.renderContent();
    }

    return rendered;
  }
}



// WEBPACK FOOTER //
// ./src/components/companiescontact/index.js